import * as React from "react";
import { debounceTimeInMs } from "./constants";
import { useHistory, useLocation } from "react-router";
export var useDebounced = function (val, delay) {
    var _a = React.useState(val), debouncedValue = _a[0], setDebouncedValue = _a[1];
    React.useEffect(function () {
        var timoutId = setTimeout(function () {
            setDebouncedValue(val);
        }, delay);
        return function () {
            clearTimeout(timoutId);
        };
    }, [val, delay]);
    return debouncedValue;
};
export var useSearchString = function () {
    var history = useHistory();
    var location = useLocation();
    var _a = React.useState((location.state && location.state.search) || ""), searchString = _a[0], setSearchString = _a[1];
    var debouncedSearchString = useDebounced(searchString, debounceTimeInMs);
    React.useEffect(function () {
        history.replace({ state: { search: searchString } });
    }, [searchString]);
    return { searchString: searchString, debouncedSearchString: debouncedSearchString, setSearchString: setSearchString };
};
export var useSearchOptions = function () {
    var history = useHistory();
    var location = useLocation();
    var _a = React.useState((location.state && location.state.search) || ""), searchString = _a[0], setSearchString = _a[1];
    var _b = React.useState((location.state && location.state.organizationId) || null), organizationId = _b[0], setOrgazationId = _b[1];
    var _c = React.useState((location.state && location.state.isOnlyIssued) || false), isOnlyIssued = _c[0], setIsOnlyIssued = _c[1];
    var _d = React.useState((location.state && location.state.orderByOption) || null), orderByOption = _d[0], setOrderByOption = _d[1];
    var debouncedSearchString = useDebounced(searchString, debounceTimeInMs);
    React.useEffect(function () {
        history.replace({
            state: {
                search: searchString,
                organizationId: organizationId,
                isOnlyIssued: isOnlyIssued,
                orderByOption: orderByOption
            }
        });
    }, [searchString, organizationId, isOnlyIssued, orderByOption]);
    return {
        searchString: searchString, organizationId: organizationId, isOnlyIssued: isOnlyIssued, debouncedSearchString: debouncedSearchString, orderByOption: orderByOption,
        setSearchString: setSearchString, setOrgazationId: setOrgazationId, setIsOnlyIssued: setIsOnlyIssued, setOrderByOption: setOrderByOption
    };
};
//# sourceMappingURL=hooks.js.map